import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "inherit",
  viewBox: "0 0 16 16"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", { d: "M12.8 6.8H9.2V3.2a1.2 1.2 0 0 0-2.4 0v3.6H3.2a1.2 1.2 0 0 0 0 2.4h3.6v3.6a1.2 1.2 0 1 0 2.4 0V9.2h3.6a1.2 1.2 0 1 0 0-2.4" }, null, -1)
  ])))
}
export default { render: render }